import { SAVE_PAGE } from './types';

export const savePage = (pageNumber, pageSize) => (dispatch) => {
    dispatch({
        type: SAVE_PAGE,
        payload: { pageNumber, pageSize },
    });
};
